// extracted by mini-css-extract-plugin
module.exports = {"typingText":"styles_typingText__z9PCV","cursor":"styles_cursor__3RUKS","blink":"styles_blink__2EpLN"};